// Integration onboarding-session api fns — carved verbatim from
// `src/api/scribeAPIV2.ts` (which now re-exports them) as D1 of the
// `integrations/connected-apps` family (ARCFE-1087).
//
// THE TWO READERS ARE NOT PLAIN REQUESTS and their shape is preserved exactly:
// both `getIntegrationOnboardingSessionById` and `getIntegrationOnboardingSessions`
// decode base64-wrapped form values on the way out, and they return DIFFERENT
// envelopes for it — the by-id fn rebuilds `{ data }` (so callers still read
// `.data`), while the list fn returns the unwrapped body. Normalising them to
// one shape would be a behaviour change, not a tidy-up.
//
// `updateIntegrationOnboardingSessionStep`, which encodes on the way IN through
// the same module, is `@domain REVIEW`, claimed by no family, and stays in the
// hub.
import type {
  CreateIntegrationOnboardingSessionRequest,
  CreateIntegrationOnboardingSessionResponse,
  GetIntegrationOnboardingSessionsQueryParams,
  SearchIntegrationOnboardingSessionsResponse,
} from '../../contracts/types';
import { http } from './connectedAppsHttp';
import { transformOnboardingStepBase64Entries } from './encoding';

export const createIntegrationOnboardingSession = (
  request: CreateIntegrationOnboardingSessionRequest
) => {
  return http().post<CreateIntegrationOnboardingSessionResponse>(
    `/integrations/onboardings/sessions`,
    request
  );
};

export const deleteIntegrationOnboardingSession = ({
  sessionId,
}: {
  sessionId: string;
}) => {
  return http().delete<null>(`/integrations/onboardings/sessions/${sessionId}`);
};

export const getIntegrationOnboardingSessionById = async (
  onboardingSessionId: string
) => {
  const data = await http().get<CreateIntegrationOnboardingSessionResponse>(
    `/integrations/onboardings/sessions/${onboardingSessionId}`
  );
  return {
    data: transformOnboardingStepBase64Entries(data.data),
  };
};

export const getIntegrationOnboardingSessions = async ({
  params,
}: {
  params: GetIntegrationOnboardingSessionsQueryParams;
}) => {
  const { data } = await http().get<SearchIntegrationOnboardingSessionsResponse>(
    `/integrations/onboardings/sessions`,
    {
      params,
    }
  );

  return {
    ...data,
    sessions: data.sessions.map((session) =>
      transformOnboardingStepBase64Entries(session)
    ),
  };
};
